import { NgModule } from '@angular/core';
import { DatePickerComponent} from "./datepicker/datepicker.component";
import { TooltipComponent } from "./tooltip/tooltip.component";
import { PredictiveComponent } from "./predictive/predictive.component";
import { ModalEmailComponent } from "./modal-email/modal-email.component";
import { ModalCommentsComponent } from "./modal-comments/modal-comments.component";
import { ModalIframeComponent } from "./iframe/modal-iframe.component";
import { ModalEmailService } from "./modal-email/modal-email.service";
import { ModalErrorComponent } from "./modal-error/modal-error.component";
import { ModalIframeService } from "./iframe/modal-iframe.service";
import { CommonModule } from '@angular/common';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Pagination } from '../pipes/pagination.pipe';
import { filterByAssignment } from '../pipes/filter-byAssignment.pipe';
import { FilterSendToApp } from '../pipes/filter-sendToApp.pipe';
import { FilterByCity } from '../pipes/filter-city.pipe';
import { orderBy } from '../pipes/orderBy.pipe';
import {ProgressBarModule} from "ngx-progress-bar";
import { orderAlphabetically } from '../pipes/orderAlphabetically.pipe';


@NgModule({

    imports: [CommonModule,DatepickerModule, FormsModule, ReactiveFormsModule, TimepickerModule.forRoot(), ModalModule.forRoot(), ProgressBarModule],
    exports: [
        DatePickerComponent,DatepickerModule, TimepickerModule, FormsModule, ModalModule, ReactiveFormsModule, PredictiveComponent, 
        ModalEmailComponent, ModalCommentsComponent, ModalIframeComponent, Pagination, filterByAssignment, orderBy, FilterByCity, 
        FilterSendToApp, ModalErrorComponent, orderAlphabetically
    ],
    declarations: [
        DatePickerComponent, PredictiveComponent, ModalEmailComponent, ModalIframeComponent, ModalCommentsComponent, Pagination, 
        filterByAssignment, orderBy, FilterByCity, FilterSendToApp, ModalErrorComponent, orderAlphabetically
    ],
    providers: [ModalEmailService, ModalIframeService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/common/shared.module.ts